import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "release-notes"
    }}>{`Release notes`}</h1>
    <h2 {...{
      "id": "may-19-2025"
    }}>{`May 19, 2025`}</h2>
    <h3 {...{
      "id": "react-native-places-701"
    }}>{`React Native Places 7.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`com.google.android.gms:play-services-location`}</inlineCode>{` from 16.0.0 to 21.2.0`}</li>
      <li parentName="ul">{`Added support for continuous native code generation in Expo`}</li>
    </ul>
    <h2 {...{
      "id": "may-13-2025"
    }}>{`May 13, 2025`}</h2>
    <h3 {...{
      "id": "ios-messaging-561"
    }}>{`iOS Messaging 5.6.1`}</h3>
    <ul>
      <li parentName="ul">{`Support for "fit to content" and "max width" in in-app messaging.`}</li>
    </ul>
    <h3 {...{
      "id": "android-bom-3120"
    }}>{`Android BOM 3.12.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.11.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.12.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.4.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.5.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.5.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-messaging-332"
    }}>{`Android Messaging 3.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for "fit to content" and "max width" in in-app messaging.`}</li>
      <li parentName="ul">{`Added gif support for push notifications on Android OS 14+ when using the Messaging extension to display push notifications.`}</li>
      <li parentName="ul">{`Fixed a logging error within the ContentCardUIProvider.`}</li>
    </ul>
    <h2 {...{
      "id": "may-12-2025"
    }}>{`May 12, 2025`}</h2>
    <h3 {...{
      "id": "android-core-340"
    }}>{`Android Core 3.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support of "Max width" and "Fit to content" for in-app messages via`}<inlineCode parentName="li">{`InAppMessageSettings`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-550"
    }}>{`iOS Core 5.5.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed issue where `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` registered multiple Analytics extensions.`}</li>
      <li parentName="ul">{`Removed call to `}<inlineCode parentName="li">{`CTCarrier`}</inlineCode>{` API for iOS 16+ as Apple deprecated it without replacement. Calling `}<inlineCode parentName="li">{`SystemInfoService.getMobileCarrierName`}</inlineCode>{` on iOS 16 and above will now always return nil.`}</li>
      <li parentName="ul">{`Added support for "Fit to content" in `}<inlineCode parentName="li">{`FullscreenMessage`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Added support of "Max width" and "Fit to content" for in-app messages via `}<inlineCode parentName="li">{`MessageSettings`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "may-8-2025"
    }}>{`May 8, 2025`}</h2>
    <h3 {...{
      "id": "ios-optimize-550"
    }}>{`iOS Optimize 5.5.0`}</h3>
    <ul>
      <li parentName="ul">{`Added generateDisplayInteractionXdm public API for a list of offers.`}</li>
      <li parentName="ul">{`Added and unwrapped weak self in Optimize's onRegistered to avoid crash.`}</li>
    </ul>
    <h2 {...{
      "id": "may-7-2025"
    }}>{`May 7, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-3110"
    }}>{`Android BOM 3.11.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.10.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.11.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.4.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.5.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-optimize-350"
    }}>{`Android Optimize 3.5.0`}</h3>
    <ul>
      <li parentName="ul">{`New API Available: Introduced `}<inlineCode parentName="li">{`[List<Offer>. generateDisplayInteractionXdm()]`}</inlineCode>{` to generate the XDM with batched list of display proposition that can be used in events tracking using Edge extension API (i.e, `}<inlineCode parentName="li">{`sendEvent()`}</inlineCode>{`).`}</li>
    </ul>
    <h2 {...{
      "id": "may-6-2025"
    }}>{`May 6, 2025`}</h2>
    <h3 {...{
      "id": "react-native-edgebridge-701"
    }}>{`React Native EdgeBridge 7.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for tvOS.`}</li>
    </ul>
    <h2 {...{
      "id": "april-28-2025"
    }}>{`April 28, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-3100"
    }}>{`Android BOM 3.10.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.9.2)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.10.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.4.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-optimize-340"
    }}>{`Android Optimize 3.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Enhanced error handling: Added support for managing invalid requests gracefully.`}</li>
      <li parentName="ul">{`New API Available: Introduced `}<inlineCode parentName="li">{`[List<Offer>.display()]`}</inlineCode>{` to track batched display proposition events for multiple offers displayed simultaneously on a screen.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-optimize-540"
    }}>{`iOS Optimize 5.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added processing of listeners asynchronously inside serial queue to solve race condition issue.`}</li>
      <li parentName="ul">{`Added a new API to support display tracking of multiple offers.`}</li>
    </ul>
    <h2 {...{
      "id": "march-28-2025"
    }}>{`March 28, 2025`}</h2>
    <h3 {...{
      "id": "react-native-core-700"
    }}>{`React Native Core 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`MobileCore.initializeWithAppId`}</inlineCode>{` and `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` APIs to simplify AEP SDK initialization by enabling automatic extension registration and lifecycle tracking.`}</li>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-assurance-700"
    }}>{`React Native Assurance 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgebridge-700"
    }}>{`React Native EdgeBridge 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgeconsent-700"
    }}>{`React Native EdgeConsent 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-campaign-classic-700"
    }}>{`React Native Campaign Classic 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Added support for the React Native New Architecture via interop layer`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgeidentity-700"
    }}>{`React Native EdgeIdentity 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-target-700"
    }}>{`React Native Target 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-userprofile-700"
    }}>{`React Native UserProfile 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-messaging-700"
    }}>{`React Native Messaging 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-places-700"
    }}>{`React Native Places 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-optimize-700"
    }}>{`React Native Optimize 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edge-700"
    }}>{`React Native Edge 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h2 {...{
      "id": "march-13-2025"
    }}>{`March 13, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-392"
    }}>{`Android BOM 3.9.2`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.9.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.9.2)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "march-11-2025"
    }}>{`March 11, 2025`}</h2>
    <h3 {...{
      "id": "android-optimize-331"
    }}>{`Android Optimize 3.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Added capability to configure timeout value for the Update Proposition API via Adobe Journey Optimizer - Decisioning card in Mobile Tags property.`}</li>
    </ul>
    <h2 {...{
      "id": "march-7-2025"
    }}>{`March 7, 2025`}</h2>
    <h3 {...{
      "id": "ios-edgebridge-510"
    }}>{`iOS EdgeBridge 5.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS support`}</li>
    </ul>
    <h2 {...{
      "id": "march-6-2025"
    }}>{`March 6, 2025`}</h2>
    <h3 {...{
      "id": "ios-optimize-530"
    }}>{`iOS Optimize 5.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added capability to configure timeout value for the Update Proposition API via Adobe Journey Optimizer - Decisioning card in Mobile Tags property.`}</li>
    </ul>
    <h3 {...{
      "id": "adobe-journey-optimizer---decisioning-extension-110"
    }}>{`Adobe Journey Optimizer - Decisioning extension 1.1.0`}</h3>
    <p>{`Added configuration capability to the Adobe Journey Optimizer - Decisioning extension in the Tags UI for mobile Tag Properties.`}</p>
    <p>{`Users can now configure:`}</p>
    <ul>
      <li parentName="ul">{`Request timeout - Set the amount of time (in seconds) to wait for a response from the decisioning services before timing out.`}</li>
    </ul>
    <h2 {...{
      "id": "march-4-2025"
    }}>{`March 4, 2025`}</h2>
    <h3 {...{
      "id": "flutter-core-500"
    }}>{`Flutter Core 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Add `}<inlineCode parentName="li">{`MobileCore.initializeWithAppId`}</inlineCode>{` and `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` APIs to simplify AEP SDK initialization by enabling automatic extension registration and lifecycle tracking.`}</li>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Add Error handling for NSError.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeconsent-500"
    }}>{`Flutter EdgeConsent 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeidentity-500"
    }}>{`Flutter EdgeIdentity 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgebridge-500"
    }}>{`Flutter EdgeBridge 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edge-500"
    }}>{`Flutter Edge 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-messaging-500"
    }}>{`Flutter Messaging 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-assurance-500"
    }}>{`Flutter Assurance 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-userprofile-500"
    }}>{`Flutter UserProfile 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "february-25-2025"
    }}>{`February 25, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-391"
    }}>{`Android BOM 3.9.1`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.9.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.9.1)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.5`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.6`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaign`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edge`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:target`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-edge-302"
    }}>{`Android Edge 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for recoverable error codes from Edge Network.`}</li>
    </ul>
    <h3 {...{
      "id": "android-core-331"
    }}>{`Android Core 3.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Allow disabling callback timeout when using `}<inlineCode parentName="li">{`MobileCore.dispatch`}</inlineCode>{` API.`}</li>
      <li parentName="ul">{`Restrict override `}<inlineCode parentName="li">{`FloatingButton`}</inlineCode>{` presentable with app theme.`}</li>
    </ul>
    <h3 {...{
      "id": "android-target-302"
    }}>{`Android Target 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added checks to prevent crashes caused by unhandled exceptions in user callbacks.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-standard-303"
    }}>{`Android Campaign Standard 3.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Added null checks to prevent crashes on extension registration.`}</li>
    </ul>
    <h3 {...{
      "id": "android-assurance-306"
    }}>{`Android Assurance 3.0.6`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue that prevented a connection error message from being displayed.`}</li>
    </ul>
    <h2 {...{
      "id": "february-24-2025"
    }}>{`February 24, 2025`}</h2>
    <h3 {...{
      "id": "ios-notification-content-extension-502"
    }}>{`iOS Notification Content Extension 5.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for custom URL handling for click interactions in notification templates.`}</li>
    </ul>
    <h2 {...{
      "id": "february-17-2025"
    }}>{`February 17, 2025`}</h2>
    <h3 {...{
      "id": "react-native-optimize-610"
    }}>{`React Native Optimize 6.1.0`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`[Breaking Change]`}</strong>{` Updated Offer Score data type of  from `}<inlineCode parentName="li">{`Integer`}</inlineCode>{` to `}<inlineCode parentName="li">{`Double`}</inlineCode>{` .`}</li>
      <li parentName="ul">{`To prevent build issues in `}<strong parentName="li">{`6.0.x`}</strong>{`, upgrade `}<inlineCode parentName="li">{`@adobe/react-native-aepoptimize`}</inlineCode>{` to `}<strong parentName="li">{`6.1.0 or later`}</strong>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "android-bom-390"
    }}>{`Android BOM 3.9.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.8.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.9.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.4`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.5`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.5`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.3.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-optimize-330"
    }}>{`Android Optimize 3.3.0`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`[Breaking Change]`}</strong>{` Updated Offer Score data type of from `}<inlineCode parentName="li">{`Integer`}</inlineCode>{` to `}<inlineCode parentName="li">{`Double`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Optimize SDK only listens to preview events if it contains `}<inlineCode parentName="li">{`debug`}</inlineCode>{` object with `}<inlineCode parentName="li">{`eventType`}</inlineCode>{` as `}<inlineCode parentName="li">{`com.adobe.eventType.edge`}</inlineCode>{` and `}<inlineCode parentName="li">{`eventSource`}</inlineCode>{` as `}<inlineCode parentName="li">{`personalization:decisions`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "february-14-2025"
    }}>{`February 14, 2025`}</h2>
    <h3 {...{
      "id": "ios-core-540"
    }}>{`iOS Core 5.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added new `}<a parentName="li" {...{
          "href": "../base/mobile-core/api-reference.md#initialize"
        }}><inlineCode parentName="a">{`MobileCore.initialize`}</inlineCode></a>{` APIs to simplify AEP SDK initialization by enabling automatic extension registration and lifecycle tracking.`}</li>
      <li parentName="ul">{`Fixed issue where in-app message scrolling was disabled when gestures were nil or empty.`}</li>
      <li parentName="ul">{`Allow disabling callback timeout when using `}<inlineCode parentName="li">{`MobileCore.dispatch`}</inlineCode>{` API.`}</li>
    </ul>
    <h2 {...{
      "id": "february-11-2025"
    }}>{`February 11, 2025`}</h2>
    <h3 {...{
      "id": "ios-optimize-521"
    }}>{`iOS Optimize 5.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where JSON object array without key was not getting parsed in Offer class.`}</li>
      <li parentName="ul">{`Added support of checking debug object's eventType and eventSource while processing debug events.`}</li>
    </ul>
    <h2 {...{
      "id": "february-10-2025"
    }}>{`February 10, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-380"
    }}>{`Android BOM 3.8.0`}</h3>
    <ul>
      <li parentName="ul">{`Starting with this BOM version, AEP SDKs offer simplified initialization. For more information, refer to the `}<a parentName="li" {...{
          "href": "../base/mobile-core/api-reference.md#initialize"
        }}><inlineCode parentName="a">{`MobileCore.initialize`}</inlineCode></a>{` API.`}</li>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.7.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.8.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:analytics`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.4`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.5`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:audience`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaign`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edge`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgebridge`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgeconsent`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgeidentity`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgemedia`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:identity`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:lifecycle`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:media`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:notificationbuilder`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.3`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.4`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:places`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:signal`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:target`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:userprofile`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-optimize-324"
    }}>{`Android Optimize 3.2.4`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-classic-313"
    }}>{`Android Campaign Classic 3.1.3`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
      <li parentName="ul">{`Updated the Notification Builder dependency to version 3.0.3 to resolve an issue that occurred when no image was provided in an input box push template notification.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgemedia-301"
    }}>{`Android EdgeMedia 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgeconsent-301"
    }}>{`Android EdgeConsent 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-messaging-331"
    }}>{`Android Messaging 3.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-target-301"
    }}>{`Android Target 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-userprofile-301"
    }}>{`Android UserProfile 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-analytics-302"
    }}>{`Android Analytics 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-standard-302"
    }}>{`Android Campaign Standard 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-media-312"
    }}>{`Android Media 3.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-301"
    }}>{`Android Edge 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-places-302"
    }}>{`Android Places 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-audience-301"
    }}>{`Android Audience 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgebridge-301"
    }}>{`Android EdgeBridge 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-assurance-305"
    }}>{`Android Assurance 3.0.5`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgeidentity-301"
    }}>{`Android EdgeIdentity 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-notification-builder-303"
    }}>{`Android Notification Builder 3.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a display issue that occurs when no image is provided in an input box push template notification.`}</li>
    </ul>
    <h3 {...{
      "id": "android-signal-301"
    }}>{`Android Signal 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-302"
    }}>{`Android Lifecycle 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-302"
    }}>{`Android Identity 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new MobileCore.initialize API introduced in Core.`}</li>
    </ul>
    <h3 {...{
      "id": "android-core-330"
    }}>{`Android Core 3.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added new `}<a parentName="li" {...{
          "href": "../base/mobile-core/api-reference.md#initialize"
        }}><inlineCode parentName="a">{`MobileCore.initialize`}</inlineCode></a>{` APIs to simplify AEP SDK initialization by enabling automatic extension registration and lifecycle tracking.`}</li>
      <li parentName="ul">{`Fixed an issue where certain HTTP request timeouts were incorrectly configured.`}</li>
    </ul>
    <h2 {...{
      "id": "february-6-2025"
    }}>{`February 6, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-370"
    }}>{`Android BOM 3.7.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.6.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.7.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.3.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-messaging-330"
    }}>{`Android Messaging 3.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Introduced support for out-of-the-box content card UI rendering using the new `}<inlineCode parentName="li">{`ContentCardUIProvider.getContentCardUI()`}</inlineCode>{` API to create and display the views for templated content cards.`}</li>
      <li parentName="ul">{`Added support to display an in-app message when the app is opened by a push notification interaction. To support this workflow, new `}<inlineCode parentName="li">{`updatePropositionsForSurfaces(List<Surface> surfaces, AdobeCallback<Boolean> callback)`}</inlineCode>{`API has been added to fetch propositions for the provided surfaces with an optional completion handler that provides a boolean status.`}</li>
    </ul>
    <h3 {...{
      "id": "android-optimize-323"
    }}>{`Android Optimize 3.2.3`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the Array type in the JSON structure of Offer Content.`}</li>
    </ul>
    <h2 {...{
      "id": "january-31-2025"
    }}>{`January 31, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-361"
    }}>{`Android BOM 3.6.1`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.6.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.6.1)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:media`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-media-311"
    }}>{`Android Media 3.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed database access-related resource leaks.`}</li>
    </ul>
    <h2 {...{
      "id": "january-16-2025"
    }}>{`January 16, 2025`}</h2>
    <h3 {...{
      "id": "ios-messaging-560"
    }}>{`iOS Messaging 5.6.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that caused dark/light image to be switched when the app enters background.`}</li>
      <li parentName="ul">{`The schemaData property, representing the associated `}<inlineCode parentName="li">{`ContentCardSchemaData`}</inlineCode>{` of `}<inlineCode parentName="li">{`ContentCardUI`}</inlineCode>{`, is now publicly accessible.`}</li>
      <li parentName="ul">{`Added API `}<inlineCode parentName="li">{`updatePropositionsForSurfaces(_:completion:)`}</inlineCode>{` to fetch propositions for the provided surfaces with an optional completion handler that provides a boolean status.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-532"
    }}>{`iOS Core 5.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where in-app message was not reframed in split screen mode.`}</li>
    </ul>
    <h2 {...{
      "id": "january-14-2025"
    }}>{`January 14, 2025`}</h2>
    <h3 {...{
      "id": "react-native-new-architecture-support"
    }}>{`React Native new architecture Support`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Updated Places Module Name`}</strong><br parentName="p"></br>{`
`}{`Added compatibility for the new architecture in the Places React Native module.  `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`New sample app with new architecture enabled`}</strong><br parentName="p"></br>{`
`}{`Enabled the new architecture in the Sample App.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Link:`}</strong>{` `}<a parentName="p" {...{
            "href": "https://github.com/adobe/aepsdk-react-native/tree/main/apps/AEPSampleAppNewArchEnabled"
          }}>{`AEPSampleAppNewArchEnabled`}</a>{`  `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`New architecture Compatibility Testing`}</strong><br parentName="p"></br>{`
`}{`Tested new architecture enabled sample app with Adobe Experience Platform Mobile React Native modules via interop layer (new architecture not supported for Adobe Campaign Classic).`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "react-native-places-603"
    }}>{`React Native Places 6.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Added new architecture compatibility to the Places React Native module.`}</li>
    </ul>
    <h2 {...{
      "id": "january-7-2025"
    }}>{`January 7, 2025`}</h2>
    <h3 {...{
      "id": "android-bom-360"
    }}>{`Android BOM 3.6.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.5.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.6.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "december-19-2024"
    }}>{`December 19, 2024`}</h2>
    <h3 {...{
      "id": "react-native-messaging-605"
    }}>{`React Native Messaging 6.0.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue with in-app messages not being displayed when a MessagingDelegate is set.`}</li>
    </ul>
    <h2 {...{
      "id": "december-6-2024"
    }}>{`December 6, 2024`}</h2>
    <h3 {...{
      "id": "android-optimize-322"
    }}>{`Android Optimize 3.2.2`}</h3>
    <ul>
      <li parentName="ul">{`Added timeout (in seconds) parameter to updatePropositions and getPropositions APIs to enable timeout configuration in both the apis ensuring that the operation either completes within the given time frame or returns an error indicating a timeout.`}</li>
      <li parentName="ul">{`Updated getPropositions API to return cached propositions immediately if there are no pending updatePropositions calls for the requested list of decision scopes.`}</li>
      <li parentName="ul">{`Added support for debug events and enabled getPropositions and onPropositionsUpdate to receive Simulated events from Assurance.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-optimize-520"
    }}>{`iOS Optimize 5.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added timeout (in seconds) parameter to updatePropositions and getPropositions APIs to enable timeout configuration in both the apis ensuring that the operation either completes within the given time frame or returns an error indicating a timeout.`}</li>
      <li parentName="ul">{`Added support for debug events and enabled getPropositions and onPropositionsUpdate to receive Simulated events from Assurance.`}</li>
    </ul>
    <h2 {...{
      "id": "november-21-2024"
    }}>{`November 21, 2024`}</h2>
    <h3 {...{
      "id": "ios-notification-content-extension-ui-512"
    }}>{`iOS Notification Content Extension ui-5.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that caused dark/light image to be switched when the app enters background.`}</li>
    </ul>
    <h2 {...{
      "id": "november-5-2024"
    }}>{`November 5, 2024`}</h2>
    <h3 {...{
      "id": "ios-notification-content-extension-ui-511"
    }}>{`iOS Notification Content Extension ui-5.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Implemented image caching for Content Card images, resolving the issue where images fail to load when reappearing after the app is relaunched from the background.`}</li>
    </ul>
    <h2 {...{
      "id": "november-1-2024"
    }}>{`November 1, 2024`}</h2>
    <h3 {...{
      "id": "ios-messaging-550"
    }}>{`iOS Messaging 5.5.0`}</h3>
    <ul>
      <li parentName="ul">{`Introduced the `}<inlineCode parentName="li">{`getContentCardUI`}</inlineCode>{` API to create and display the UI for templated content cards, supported on iOS 15 and above.`}</li>
      <li parentName="ul">{`Added new property "priority" to "Proposition" class which represents the priority entered in the AJO UI for the corresponding campaign.`}</li>
    </ul>
    <h2 {...{
      "id": "october-29-2024"
    }}>{`October 29, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-351"
    }}>{`Android BOM 3.5.1`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.5.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.5.1)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.3`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.4`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-bom-2910"
    }}>{`Android BOM 2.9.10`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.9)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.10)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.8`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.8`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-assurance-304"
    }}>{`Android Assurance 3.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue causing incorrect application details to be sent in the `}<inlineCode parentName="li">{`client`}</inlineCode>{` event.`}</li>
    </ul>
    <h3 {...{
      "id": "android-assurance-222"
    }}>{`Android Assurance 2.2.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue causing incorrect application details to be sent in the `}<inlineCode parentName="li">{`client`}</inlineCode>{` event.`}</li>
    </ul>
    <h2 {...{
      "id": "october-16-2024"
    }}>{`October 16, 2024`}</h2>
    <h3 {...{
      "id": "ios-edge-503"
    }}>{`iOS Edge 5.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Adds 507 as recoverable error code and applies valid retry-after timeout values on next retry if provided on the response, otherwise applies default timeout.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-531"
    }}>{`iOS Core 5.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`responseHttpHeader(forKey:)`}</inlineCode>{` in `}<inlineCode parentName="li">{`HttpConnection`}</inlineCode>{` struct to ensure case-insensitive header field lookups.`}</li>
    </ul>
    <h2 {...{
      "id": "october-8-2024"
    }}>{`October 8, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-350"
    }}>{`Android BOM 3.5.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.4.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.5.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-optimize-310"
    }}>{`Android Optimize 3.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a new `}<inlineCode parentName="li">{`updatePropositions`}</inlineCode>{` API to support completion callback with retrieved propositions and errors (if any).`}</li>
    </ul>
    <h2 {...{
      "id": "october-3-2024"
    }}>{`October 3, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-340"
    }}>{`Android BOM 3.4.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.3.2)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.4.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "ios-optimize-510"
    }}>{`iOS Optimize 5.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a new `}<inlineCode parentName="li">{`updatePropositions`}</inlineCode>{` API to support completion callback with retrieved propositions and errors (if any).`}</li>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`getPropositions`}</inlineCode>{` API to return cached propositions immediately if there are no pending `}<inlineCode parentName="li">{`updatePropositions`}</inlineCode>{` calls for the requested list of decision scopes.`}</li>
      <li parentName="ul">{`Changed `}<inlineCode parentName="li">{`Offer.score`}</inlineCode>{` data type from Integer to Double to fix a bug where offers having decimal score were being dropped.`}</li>
    </ul>
    <h2 {...{
      "id": "october-2-2024"
    }}>{`October 2, 2024`}</h2>
    <h3 {...{
      "id": "android-messaging-321"
    }}>{`Android Messaging 3.2.1`}</h3>
    <ul>
      <li parentName="ul">{`SDK updated to support conflict resolution for in-app messaging:`}
        <ul parentName="li">
          <li parentName="ul">{`In-app messages are loaded in priority order`}</li>
          <li parentName="ul">{`When a message display is suppressed due to a priority conflict or due to app developer decision it is recorded as an edge event`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "october-1-2024"
    }}>{`October 1, 2024`}</h2>
    <h3 {...{
      "id": "android-core-320"
    }}>{`Android Core 3.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added new constants to `}<inlineCode parentName="li">{`AEPError`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`SuppressedByAppDeveloper`}</inlineCode>{` constant to indicate that the in-app message was not displayed because it was rejected by the app developer via the `}<inlineCode parentName="li">{`PresentationDelegate`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "september-30-2024"
    }}>{`September 30, 2024`}</h2>
    <h3 {...{
      "id": "ios-messaging-540"
    }}>{`iOS Messaging 5.4.0`}</h3>
    <ul>
      <li parentName="ul">{`SDK updated to support conflict resolution for in-app messaging:`}
        <ul parentName="li">
          <li parentName="ul">{`In-app messages are loaded in priority order`}</li>
          <li parentName="ul">{`When a message display is suppressed due to a priority conflict or due to app developer decision it is recorded as an edge event`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "september-27-2024"
    }}>{`September 27, 2024`}</h2>
    <h3 {...{
      "id": "ios-core-530"
    }}>{`iOS Core 5.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added an `}<inlineCode parentName="li">{`onError`}</inlineCode>{` method to the `}<inlineCode parentName="li">{`FullscreenMessageDelegate`}</inlineCode>{` to notify of the reason when an in-app message fails to display.`}</li>
    </ul>
    <h2 {...{
      "id": "september-13-2024"
    }}>{`September 13, 2024`}</h2>
    <h3 {...{
      "id": "roku-sdk-130"
    }}>{`Roku SDK 1.3.0`}</h3>
    <h4 {...{
      "id": "consent-support"
    }}>{`Consent Support`}</h4>
    <ul>
      <li parentName="ul">{`The SDK now allows `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-roku/blob/main/Documentation/api-reference.md#configure-default-consent"
        }}>{`configuring default consent`}</a>{`.`}</li>
      <li parentName="ul">{`Added a `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-roku/blob/main/Documentation/api-reference.md#setconsent"
        }}>{`setConsent`}</a>{` API for collecting user consent preferences.`}</li>
    </ul>
    <h4 {...{
      "id": "other-changes"
    }}>{`Other Changes`}</h4>
    <ul>
      <li parentName="ul">{`Adds support for persisting the `}<inlineCode parentName="li">{`locationHint`}</inlineCode>{` and other states returned by the Edge Network, using them to enhance the user experience by ensuring more consistent routing and improved session continuity.`}</li>
    </ul>
    <h2 {...{
      "id": "september-12-2024"
    }}>{`September 12, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-332"
    }}>{`Android BOM 3.3.2`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.3.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.3.2)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:notificationbuilder`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "september-10-2024"
    }}>{`September 10, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-312"
    }}>{`Android Campaign Classic 3.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Update notification builder dependency to 3.0.2 to resolve an issue with push template dismiss actions.`}</li>
    </ul>
    <h3 {...{
      "id": "android-notification-builder-302"
    }}>{`Android Notification Builder 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Add `}<inlineCode parentName="li">{`aep`}</inlineCode>{` prefix to notification builder string resources to prevent conflicts with resources defined by the app.`}</li>
      <li parentName="ul">{`Fix intent actions to allow tracker activities to correctly handle received intents.`}</li>
    </ul>
    <h2 {...{
      "id": "september-4-2024"
    }}>{`September 4, 2024`}</h2>
    <h3 {...{
      "id": "aepswiftui-510-beta"
    }}>{`AEPSwiftUI 5.1.0-beta`}</h3>
    <p>{`Initial release of `}<inlineCode parentName="p">{`AEPSwiftUI`}</inlineCode>{` framework for Adobe Experience Platform Mobile SDKs on iOS. The `}<inlineCode parentName="p">{`AEPSwiftUI`}</inlineCode>{` framework provides out-of-the-box UI components for use with Adobe Journey Optimizer content cards.`}</p>
    <p>{`The first release includes a single template - `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-ui-ios/tree/v5.1.0-beta/Frameworks/AEPSwiftUI/Documentation"
      }}>{`SmallImageTemplate`}</a></p>
    <h2 {...{
      "id": "september-3-2024"
    }}>{`September 3, 2024`}</h2>
    <h3 {...{
      "id": "ios-notification-content-extension-501"
    }}>{`iOS Notification Content Extension 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Removed left and right scroll buttons on auto carousel notifications.`}</li>
    </ul>
    <h3 {...{
      "id": "android-bom-331"
    }}>{`Android BOM 3.3.1`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.3.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.3.1)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-core-312"
    }}>{`Android Core 3.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Added screen reader support for in-app messages.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-messaging-530"
    }}>{`iOS Messaging 5.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Two updates made to support out-of-the-box Content Card templates, coming soon via the new `}<inlineCode parentName="li">{`AEPSwiftUI`}</inlineCode>{` library:`}
        <ul parentName="li">
          <li parentName="ul">{`Writes a disqualify event to event history when a content card is dismissed`}</li>
          <li parentName="ul">{`Removes dismissed content card from in-memory container holding qualified content cards`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "august-20-2024"
    }}>{`August 20, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-330"
    }}>{`Android BOM 3.3.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.2.2)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.3.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaign`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.2.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:notificationbuilder`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:places`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-campaign-classic-311"
    }}>{`Android Campaign Classic 3.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Removed unused `}<inlineCode parentName="li">{`app_name`}</inlineCode>{` string resource to prevent conflicts with resources defined by the app.`}</li>
      <li parentName="ul">{`Add support for 64-bit broadlog id.`}</li>
      <li parentName="ul">{`Update notification builder dependency to 3.0.1 to resolve issues with out-of-the-box push templates.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-standard-301"
    }}>{`Android Campaign Standard 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Removed unused `}<inlineCode parentName="li">{`app_name`}</inlineCode>{` string resource to prevent conflicts with resources defined by the app.`}</li>
      <li parentName="ul">{`Fixed an Android Campaign Standard 2.x datastore migration issue.`}</li>
    </ul>
    <h3 {...{
      "id": "android-optimize-302"
    }}>{`Android Optimize 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed thread safety for map updates that happen when `}<inlineCode parentName="li">{`updatePropositions`}</inlineCode>{` API was called repeatedly.`}</li>
      <li parentName="ul">{`Fixed issue where `}<inlineCode parentName="li">{`Offer`}</inlineCode>{` could not be created for default content item when `}<inlineCode parentName="li">{`getPropostions`}</inlineCode>{` API was called.`}</li>
    </ul>
    <h3 {...{
      "id": "android-notification-builder-301"
    }}>{`Android Notification Builder 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed timer notification background color.`}</li>
      <li parentName="ul">{`Updated optional fields within the multi-icon push template.`}</li>
      <li parentName="ul">{`Fixed issues seen with lower level Android API. See `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-ui-android/pull/64"
        }}>{`https://github.com/adobe/aepsdk-ui-android/pull/64`}</a>{` for details.`}</li>
    </ul>
    <h2 {...{
      "id": "august-19-2024"
    }}>{`August 19, 2024`}</h2>
    <h3 {...{
      "id": "android-places-301"
    }}>{`Android Places 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Removed unused `}<inlineCode parentName="li">{`app_name`}</inlineCode>{` string resource to prevent conflicts with resources defined by the app.`}</li>
    </ul>
    <h3 {...{
      "id": "android-messaging-320"
    }}>{`Android Messaging 3.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Deprecated `}<inlineCode parentName="li">{`ContentCard`}</inlineCode>{` class and its related APIs.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-messaging-520"
    }}>{`iOS Messaging 5.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated some logging around push message tracking to be more useful.`}</li>
      <li parentName="ul">{`Deprecated `}<inlineCode parentName="li">{`ContentCard`}</inlineCode>{` class and its related APIs.`}</li>
    </ul>
    <h2 {...{
      "id": "august-16-2024"
    }}>{`August 16, 2024`}</h2>
    <h3 {...{
      "id": "android-assurance-303"
    }}>{`Android Assurance 3.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Removed `}<inlineCode parentName="li">{`app_name`}</inlineCode>{` string resource to prevent conflicts with resources defined by the app.`}</li>
    </ul>
    <h2 {...{
      "id": "august-12-2024"
    }}>{`August 12, 2024`}</h2>
    <h3 {...{
      "id": "android-assurance-302"
    }}>{`Android Assurance 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added localization support.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-assurance-501"
    }}>{`iOS Assurance 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Add localization support.`}</li>
    </ul>
    <h2 {...{
      "id": "july-19-2024"
    }}>{`July 19, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-322"
    }}>{`Android BOM 3.2.2`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.2.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.2.2)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-core-311"
    }}>{`Android Core 3.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue causing in-app messages to cast a shadow.`}</li>
      <li parentName="ul">{`Fixed an issue causing in-app messages to be slightly transparent by default.`}</li>
      <li parentName="ul">{`Improved in-app message handling in immersive mode.`}</li>
    </ul>
    <h2 {...{
      "id": "july-9-2024"
    }}>{`July 9, 2024`}</h2>
    <h3 {...{
      "id": "ios-messaging-511"
    }}>{`iOS Messaging 5.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a regression introduced in 5.0.0 that was preventing cached in-app messages from displaying on launch.`}</li>
    </ul>
    <h2 {...{
      "id": "june-28-2024"
    }}>{`June 28, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-321"
    }}>{`Android BOM 3.2.1`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.2.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.2.1)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:analytics`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "june-27-2024"
    }}>{`June 27, 2024`}</h2>
    <h3 {...{
      "id": "ios-analytics-502"
    }}>{`iOS Analytics 5.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where Places region ID and name were not included in the Analytics request if the Places data contained non-string values.`}</li>
    </ul>
    <h3 {...{
      "id": "android-analytics-301"
    }}>{`Android Analytics 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where Places region ID and name were not included in the Analytics request if the Places data contained non-string values.`}</li>
    </ul>
    <h2 {...{
      "id": "june-26-2024"
    }}>{`June 26, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-320"
    }}>{`Android BOM 3.2.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.1.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.2.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:notificationbuilder`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-messaging-310"
    }}>{`Android Messaging 3.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-messaging-android/blob/main/Documentation/sources/propositions/content-card.md"
        }}>{`Content Cards`}</a>{`.`}</li>
      <li parentName="ul">{`Fixed a bug causing modified code-based experiences to be appended to the proposition offering, rather than being replaced.`}</li>
      <li parentName="ul">{`Added listener for debug event to support future Assurance workflows.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-messaging-510"
    }}>{`iOS Messaging 5.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-messaging-ios/blob/main/Documentation/sources/propositions/developer-documentation/classes/content-card.md"
        }}>{`Content Cards`}</a>{`.`}</li>
      <li parentName="ul">{`Fixed a bug causing modified code-based experiences to be appended to the proposition offering, rather than being replaced.`}</li>
      <li parentName="ul">{`Added listener for debug event to support future Assurance workflows.`}</li>
    </ul>
    <h2 {...{
      "id": "june-24-2024"
    }}>{`June 24, 2024`}</h2>
    <h3 {...{
      "id": "android-core-264"
    }}>{`Android Core 2.6.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed strict mode violations that happened during SDK initialization.`}</li>
      <li parentName="ul">{`Added checks to prevent SDK initialization when the device is in direct boot mode.`}</li>
    </ul>
    <h3 {...{
      "id": "android-bom-299"
    }}>{`Android BOM 2.9.9`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.8)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.9)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.6`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.8`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.6.3`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.6.4`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "june-21-2024"
    }}>{`June 21, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-310"
    }}>{`Android BOM 3.1.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.3)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.1.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:notificationbuilder`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-campaign-classic-310"
    }}>{`Android Campaign Classic 3.1.0`}</h3>
    <p>{`Add support for out-of-the-box push notifications:`}</p>
    <ul>
      <li parentName="ul">{`Basic`}</li>
      <li parentName="ul">{`Carousel`}</li>
      <li parentName="ul">{`Product Catalog`}</li>
      <li parentName="ul">{`Product Rating`}</li>
      <li parentName="ul">{`Input Box`}</li>
      <li parentName="ul">{`Multi Icon`}</li>
      <li parentName="ul">{`Zero Bezel`}</li>
      <li parentName="ul">{`Timer`}</li>
    </ul>
    <h3 {...{
      "id": "android-notification-builder-300"
    }}>{`Android Notification Builder 3.0.0`}</h3>
    <p>{`This is the initial release of AEP Notification Builder. Added support for out-of-the-box push notifications:`}</p>
    <ul>
      <li parentName="ul">{`Basic`}</li>
      <li parentName="ul">{`Carousel`}</li>
      <li parentName="ul">{`Product Catalog`}</li>
      <li parentName="ul">{`Product Rating`}</li>
      <li parentName="ul">{`Input Box`}</li>
      <li parentName="ul">{`Multi Icon`}</li>
      <li parentName="ul">{`Zero Bezel`}</li>
      <li parentName="ul">{`Timer`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-520"
    }}>{`iOS Core 5.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a new EventSource constant (`}<inlineCode parentName="li">{`com.adobe.eventSource.debug`}</inlineCode>{`) and utility methods.`}</li>
      <li parentName="ul">{`Added support for in-app message HTML content to control its background transparency.`}</li>
      <li parentName="ul">{`Fixed data races in EventHub and Services and implemented additional stability fixes.`}</li>
    </ul>
    <h2 {...{
      "id": "june-20-2024"
    }}>{`June 20, 2024`}</h2>
    <h3 {...{
      "id": "android-core-310"
    }}>{`Android Core 3.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for in-app message HTML content to control its background transparency.`}</li>
      <li parentName="ul">{`Enhanced Presentable re-attachment workflow for new Activity launch scenarios.`}</li>
      <li parentName="ul">{`Added a new EventSource constant (`}<inlineCode parentName="li">{`com.adobe.eventSource.debug`}</inlineCode>{`) and utility methods.`}</li>
      <li parentName="ul">{`Added checks to prevent SDK initialization when device is in direct boot mode.`}</li>
    </ul>
    <h2 {...{
      "id": "june-6-2024"
    }}>{`June 6, 2024`}</h2>
    <h3 {...{
      "id": "react-native-edgeconsent-602"
    }}>{`React Native EdgeConsent 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-userprofile-602"
    }}>{`React Native UserProfile 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-target-602"
    }}>{`React Native Target 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-places-602"
    }}>{`React Native Places 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-optimize-602"
    }}>{`React Native Optimize 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-messaging-602"
    }}>{`React Native Messaging 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgeidentity-602"
    }}>{`React Native EdgeIdentity 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgebridge-602"
    }}>{`React Native EdgeBridge 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edge-602"
    }}>{`React Native Edge 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-campaign-classic-602"
    }}>{`React Native Campaign Classic 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-assurance-602"
    }}>{`React Native Assurance 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-core-602"
    }}>{`React Native Core 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h2 {...{
      "id": "june-4-2024"
    }}>{`June 4, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-303"
    }}>{`Android BOM 3.0.3`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.2)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.3)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-core-302"
    }}>{`Android Core 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed strict mode violations that happened during SDK initialization.`}</li>
    </ul>
    <h3 {...{
      "id": "android-assurance-301"
    }}>{`Android Assurance 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where the Assurance floating button was not immediately shown in a reconnection scenario.`}</li>
      <li parentName="ul">{`Fixed an issue where the QuickConnect device registration status check job was not terminated when the connection attempt is cancelled.`}</li>
      <li parentName="ul">{`Disabled content and file access from `}<inlineCode parentName="li">{`WebView`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "may-31-2024"
    }}>{`May 31, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-218"
    }}>{`Android Campaign Classic 2.1.8`}</h3>
    <ul>
      <li parentName="ul">{`Fix clipped carousel captions which was occurring on smaller devices.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-media-501"
    }}>{`iOS Media 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue in Media hit processor and now it retries hits on recoverable URLErrors shared by Mobile Core.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-audience-501"
    }}>{`iOS Audience 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue in Audience hit processor and now it retries hits on recoverable URLErrors shared by Mobile Core.`}</li>
    </ul>
    <h2 {...{
      "id": "may-28-2024"
    }}>{`May 28, 2024`}</h2>
    <h3 {...{
      "id": "ios-analytics-501"
    }}>{`iOS Analytics 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue in Analytics hit processor and now it retries hits on recoverable URLErrors shared by Mobile Core.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edge-502"
    }}>{`iOS Edge 5.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue in Edge hit processor and now it retries hits on recoverable URLErrors shared by Mobile Core.`}</li>
    </ul>
    <h2 {...{
      "id": "may-23-2024"
    }}>{`May 23, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-302"
    }}>{`Android BOM 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.2)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:identity`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:lifecycle`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-lifecycle-301"
    }}>{`Android Lifecycle 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Lifecycle extension now computes the `}<inlineCode parentName="li">{`xdm:isUpgrade`}</inlineCode>{` metric in the `}<inlineCode parentName="li">{`application.launch`}</inlineCode>{` event when either versionName or versionCode changes.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-301"
    }}>{`Android Identity 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an edge case where `}<inlineCode parentName="li">{`a.push.optin=false`}</inlineCode>{` event may be sent to Analytics even when `}<inlineCode parentName="li">{`MobileCore.setPushIdentifier()`}</inlineCode>{` API is not used.`}</li>
    </ul>
    <h3 {...{
      "id": "android-core-301"
    }}>{`Android Core 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue with scrollability in in-app messages with overflowing content.`}</li>
      <li parentName="ul">{`Fixed an issue where the PresentationDelegate was not notified of all URLs opened by an in-app message.`}</li>
      <li parentName="ul">{`Fixed an issue where UI components were not adapting to orientation changes when the activity hosting the composable restricts configuration change.`}</li>
      <li parentName="ul">{`Enhanced error handling in the collectLaunchInfo API to catch exceptions when retrieving bundled data from an Activity.`}</li>
      <li parentName="ul">{`Simplified coroutine scope management in UI services.`}</li>
    </ul>
    <h2 {...{
      "id": "may-22-2024"
    }}>{`May 22, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-217"
    }}>{`Android Campaign Classic 2.1.7`}</h3>
    <ul>
      <li parentName="ul">{`Add support for dark mode with out of the box push template notifications. Dark mode is supported on API29+ only and any custom color modifications made to the push payload will override the dark/light mode colors.`}</li>
      <li parentName="ul">{`Removed the SCHEDULE_EXACT_ALARM permission from the Campaign Classic extension. This permission must be added to the app manifest if exact scheduling is needed for remind later notifications. If an API less than S / 31 is in use, or the exact alarm permission wasn't granted to the app, then an inexact alarm is used instead. Inexact scheduling will display the scheduled notification within a 1 hour window starting with the given timestamp.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-510"
    }}>{`iOS Core 5.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a new constant and a utility method to AEPServices to detect if `}<inlineCode parentName="li">{`URLError`}</inlineCode>{` is recoverable.`}</li>
      <li parentName="ul">{`Lifecycle extension now computes the `}<inlineCode parentName="li">{`xdm:isUpgrade`}</inlineCode>{` metric in the `}<inlineCode parentName="li">{`application.launch`}</inlineCode>{` event when either CFBundleShortVersionString or CFBundleVersion changes.`}</li>
      <li parentName="ul">{`Fixed an issue in the Signal and Identity extensions that caused the hit processor to drop queued hits when the device's network was offline.`}</li>
      <li parentName="ul">{`Fixed an edge case where `}<inlineCode parentName="li">{`a.push.optin=false`}</inlineCode>{` event may be sent to Analytics even when `}<inlineCode parentName="li">{`MobileCore.setPushIdentifier()`}</inlineCode>{` API is not used.`}</li>
      <li parentName="ul">{`Fixed data races in ExtensionContainer, ApplicationSystemInfoService, DiskCacheService, and FileSystemNamedCollection.`}</li>
    </ul>
    <h2 {...{
      "id": "may-21-2024"
    }}>{`May 21, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-301"
    }}>{`Android BOM 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.1)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "ios-optimize-501"
    }}>{`iOS Optimize 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash that happens when `}<inlineCode parentName="li">{`updateProposition`}</inlineCode>{` API was called repeatedly.`}</li>
    </ul>
    <h3 {...{
      "id": "android-optimize-301"
    }}>{`Android Optimize 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where Optimize SDK was considering Target mbox decision scope strings as invalid and not including them in personalization requests.`}</li>
    </ul>
    <h2 {...{
      "id": "may-20-2024"
    }}>{`May 20, 2024`}</h2>
    <h3 {...{
      "id": "ios-core-424"
    }}>{`iOS Core 4.2.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a race condition when accessing sharedStateName inside ExtensionContainer.`}</li>
    </ul>
    <h2 {...{
      "id": "may-18-2024"
    }}>{`May 18, 2024`}</h2>
    <h3 {...{
      "id": "ios-optimize-404"
    }}>{`iOS Optimize 4.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash that happens when `}<inlineCode parentName="li">{`updateProposition`}</inlineCode>{` API was called repeatedly.`}</li>
    </ul>
    <h2 {...{
      "id": "may-13-2024"
    }}>{`May 13, 2024`}</h2>
    <h3 {...{
      "id": "flutter-edge-410"
    }}>{`Flutter Edge 4.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support to customize datastream configurations on a per-event basis using the sendEvent API.`}</li>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-userprofile-402"
    }}>{`Flutter UserProfile 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-messaging-402"
    }}>{`Flutter Messaging 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeidentity-402"
    }}>{`Flutter EdgeIdentity 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeconsent-402"
    }}>{`Flutter EdgeConsent 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgebridge-402"
    }}>{`Flutter EdgeBridge 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-assurance-402"
    }}>{`Flutter Assurance 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-core-402"
    }}>{`Flutter Core 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h3 {...{
      "id": "android-bom-298"
    }}>{`Android BOM 2.9.8`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.7)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.8)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.6.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.6.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-core-263"
    }}>{`Android Core 2.6.3`}</h3>
    <ul>
      <li parentName="ul">{`Enhanced error handling in the `}<inlineCode parentName="li">{`collectLaunchInfo`}</inlineCode>{` API to catch exceptions when retrieving bundled data from an Activity.`}</li>
    </ul>
    <h2 {...{
      "id": "may-3-2024"
    }}>{`May 3, 2024`}</h2>
    <h3 {...{
      "id": "roku-sdk-120"
    }}>{`Roku SDK 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for Datastream overrides, allowing for more flexibility in configuring the Datastream.`}</li>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`getExperienceCloudId()`}</inlineCode>{` API, which enables developers to retrieve the Experience Cloud ID (ECID) from the SDK.`}</li>
    </ul>
    <h2 {...{
      "id": "may-2-2024"
    }}>{`May 2, 2024`}</h2>
    <h3 {...{
      "id": "ios-edge-501"
    }}>{`iOS Edge 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Edge requests now retrieve the configuration state at the time the requests are queued, instead of at the time the requests are sent.`}</li>
    </ul>
    <h2 {...{
      "id": "april-30-2024"
    }}>{`April 30, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-297"
    }}>{`Android BOM 2.9.7`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.6)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.7)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.5`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.6`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "april-29-2024"
    }}>{`April 29, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-216"
    }}>{`Android Campaign Classic 2.1.6`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that caused Activity to restart when processing push notification click URIs.`}</li>
      <li parentName="ul">{`Fixed a bug to prevent images from being cropped in carousel push template.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-notification-content-extension-500"
    }}>{`iOS Notification Content Extension 5.0.0`}</h3>
    <p>{`Initial release of `}<inlineCode parentName="p">{`AEPNotificationContent`}</inlineCode>{` extension for Adobe Experience Platform Mobile SDKs on iOS.  The `}<inlineCode parentName="p">{`AEPNotificationContent`}</inlineCode>{` extension is used in conjunction with `}<inlineCode parentName="p">{`AEPCampaignClassic`}</inlineCode>{` to deliver templated push notifications.  `}</p>
    <p>{`The first release includes the following templates:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../resources/reference/push-notifications/templates/basic.md"
        }}>{`Basic`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../resources/reference/push-notifications/templates/carousel.md"
        }}>{`Carousel`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../resources/reference/push-notifications/templates/timer.md"
        }}>{`Timer`}</a></li>
    </ul>
    <p>{`See the `}<a parentName="p" {...{
        "href": "../../resources/reference/push-notifications/index.md"
      }}>{`documentation`}</a>{` for more information.`}</p>
    <h2 {...{
      "id": "april-24-2024"
    }}>{`April 24, 2024`}</h2>
    <h3 {...{
      "id": "react-native-core-601"
    }}>{`React Native Core 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-optimize-601"
    }}>{`React Native Optimize 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-places-601"
    }}>{`React Native Places 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-target-601"
    }}>{`React Native Target 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-userprofile-601"
    }}>{`React Native UserProfile 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-messaging-601"
    }}>{`React Native Messaging 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgeidentity-601"
    }}>{`React Native EdgeIdentity 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edge-601"
    }}>{`React Native Edge 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgebridge-601"
    }}>{`React Native EdgeBridge 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgeconsent-601"
    }}>{`React Native EdgeConsent 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-campaign-standard-601"
    }}>{`React Native Campaign Standard 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-assurance-601"
    }}>{`React Native Assurance 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h2 {...{
      "id": "april-23-2024"
    }}>{`April 23, 2024`}</h2>
    <h3 {...{
      "id": "flutter-core-401"
    }}>{`Flutter Core 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeidentity-401"
    }}>{`Flutter EdgeIdentity 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeconsent-401"
    }}>{`Flutter EdgeConsent 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgebridge-401"
    }}>{`Flutter EdgeBridge 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edge-401"
    }}>{`Flutter Edge 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-messaging-401"
    }}>{`Flutter Messaging 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-userprofile-401"
    }}>{`Flutter UserProfile 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-assurance-401"
    }}>{`Flutter Assurance 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h2 {...{
      "id": "april-16-2024"
    }}>{`April 16, 2024`}</h2>
    <h3 {...{
      "id": "flutter-core-4x-and-compatible-plugins"
    }}>{`Flutter Core 4.x and compatible plugins`}</h3>
    <p>{`A new major version of the `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/core"
      }}>{`Adobe Experience Platform Core Flutter Plugin`}</a>{` has been released along with updates to other plugins. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs, which include the `}<inlineCode parentName="li">{`privacy manifest`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`MobileCore.dispatchEventWithResponseCallback`}</inlineCode>{` API with a timeout parameter.`}</li>
    </ul>
    <p>{`Note that all these plugins must be updated together.`}</p>
    <ul>
      <li parentName="ul">{`flutter_aepcore:4.0.0`}</li>
      <li parentName="ul">{`flutter_aepuserprofile:4.0.0`}</li>
      <li parentName="ul">{`flutter_aepassurance:4.0.0`}</li>
      <li parentName="ul">{`flutter_aepedge:4.0.0`}</li>
      <li parentName="ul">{`flutter_aepedgeidentity:4.0.0`}</li>
      <li parentName="ul">{`flutter-aepedgeconsent:4.0.0`}</li>
      <li parentName="ul">{`flutter-aepedgebridge:4.0.0`}</li>
      <li parentName="ul">{`flutter-aepmessaging:4.0.0`}</li>
    </ul>
    <p>{`To learn how Apple's privacy related announcements made in WWDC of 2023 affect the Mobile SDK, please read the guide on `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/resources/privacy-manifest"
      }}>{`iOS privacy manifest requirements`}</a>{`.`}</p>
    <h3 {...{
      "id": "flutter-edgebridge-400"
    }}>{`Flutter EdgeBridge 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepedgebridge"
      }}>{`Edge Bridge`}</a>{` for Adobe Experience Platform Flutter Plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated Edge Bridge data format to enhance support for migrating to sending data via Edge Network to Adobe Analytics and reduce the effort required for mapping data to XDM.`}</li>
      <li parentName="ul">{`If you are currently using Flutter Edge Bridge version 3.x  and you are mapping data to XDM in your datastream, adjustments will be necessary when adopting version 4.0.0.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-messaging-400"
    }}>{`Flutter Messaging 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepmessaging"
      }}>{`Adobe Journey Optimizer`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Adds `}<inlineCode parentName="li">{`onContentLoaded`}</inlineCode>{` to `}<inlineCode parentName="li">{`MessagingDelegate`}</inlineCode>{` (Android Only).`}</li>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`urlLoaded`}</inlineCode>{` from `}<inlineCode parentName="li">{`MessagingDelegate`}</inlineCode>{` to iOS Only.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeidentity-400"
    }}>{`Flutter EdgeIdentity 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepedgeidentity"
      }}>{`Identity for Edge Network`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edgeconsent-400"
    }}>{`Flutter EdgeConsent 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepedgeconsent"
      }}>{`Consent for Edge Network`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-edge-400"
    }}>{`Flutter Edge 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepedge"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-userprofile-400"
    }}>{`Flutter UserProfile 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepuserprofile"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter-assurance-400"
    }}>{`Flutter Assurance 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepassurance"
      }}>{`Assurance`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h2 {...{
      "id": "april-12-2024"
    }}>{`April 12, 2024`}</h2>
    <h3 {...{
      "id": "react-native-core-6x-and-compatible-libraries"
    }}>{`React Native Core 6.x and compatible libraries`}</h3>
    <p>{`A new major version of the `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/core"
      }}>{`Adobe Experience Platform Core React Native library`}</a>{` has been released along with updates to other libraries. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs, which include the `}<inlineCode parentName="li">{`privacy manifest`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Deprecated `}<inlineCode parentName="li">{`MobileCore.log`}</inlineCode>{`API to align with the native platforms.`}</li>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`MobileCore.dispatchEventWithResponseCallback`}</inlineCode>{` API with a timeout parameter.`}</li>
    </ul>
    <p>{`Note that all these libraries must be updated together.`}</p>
    <ul>
      <li parentName="ul">{`@adobe/react-native-aepcore:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepuserprofile:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepedge:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aeedgeidentity:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepedgeconsent:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepedgebridge:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepmessaging:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepassurance:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepoptimize:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepplaces:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aeptarget:6.0.0`}</li>
      <li parentName="ul">{`@adobe/react-native-aepcampaignclassic:6.0.0`}</li>
    </ul>
    <p>{`To learn how Apple's privacy related announcements made in WWDC of 2023 affect the Mobile SDK, please read the guide on `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/resources/privacy-manifest"
      }}>{`iOS privacy manifest requirements`}</a>{`.`}</p>
    <h3 {...{
      "id": "react-native-edgebridge-600"
    }}>{`React Native EdgeBridge 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/edgebridge"
      }}>{`Edge Bridge`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated Edge Bridge data format to enhance support for migrating to sending data via Edge Network to Adobe Analytics and reduce the effort required for mapping data to XDM.`}</li>
      <li parentName="ul">{`If you are currently using React Native Edge Bridge version 5.x  and you are mapping data to XDM in your datastream, adjustments will be necessary when adopting version 6.0.0.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-campaign-standard-600"
    }}>{`React Native Campaign Standard 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/campaignclassic"
      }}>{`Campaign Classic`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-target-600"
    }}>{`React Native Target 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/target"
      }}>{`Target`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-places-600"
    }}>{`React Native Places 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/places"
      }}>{`Places`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-optimize-600"
    }}>{`React Native Optimize 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/optimize"
      }}>{`Adobe Journey Optimizer - Decisioning Extension`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-messaging-600"
    }}>{`React Native Messaging 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/messaging"
      }}>{`Adobe Journey Optimizer`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Adds `}<inlineCode parentName="li">{`onContentLoaded`}</inlineCode>{` to `}<inlineCode parentName="li">{`MessagingDelegate`}</inlineCode>{` (Android Only).`}</li>
      <li parentName="ul">{`Updated `}<inlineCode parentName="li">{`urlLoaded`}</inlineCode>{` from `}<inlineCode parentName="li">{`MessagingDelegate`}</inlineCode>{` to iOS Only.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgeconsent-600"
    }}>{`React Native EdgeConsent 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/edgeconsent"
      }}>{`Consent`}</a>{` for Edge Network for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edgeidentity-600"
    }}>{`React Native EdgeIdentity 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/edgeidentity"
      }}>{`Identity for Edge Network`}</a>{` Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-edge-600"
    }}>{`React Native Edge 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/edge"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-userprofile-600"
    }}>{`React Native UserProfile 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/userprofile"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-assurance-600"
    }}>{`React Native Assurance 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/assurance"
      }}>{`Assurance`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h2 {...{
      "id": "april-3-2024"
    }}>{`April 3, 2024`}</h2>
    <h3 {...{
      "id": "android-mobile-core-3x-and-compatible-extensions"
    }}>{`Android Mobile Core 3.x and compatible extensions`}</h3>
    <p>{`New major version of the Mobile Core SDK for Android has been released along with updates to other extensions. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`The SDK is now compatible with Kotlin 1.8 and higher.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
      <li parentName="ul">{`Migrated UI service to use Jetpack Compose.`}</li>
    </ul>
    <p>{`Note that all these extensions must be updated together.`}</p>
    <ul>
      <li parentName="ul">{`Android Mobile Core 3.0.0`}</li>
      <li parentName="ul">{`Android Signal 3.0.0`}</li>
      <li parentName="ul">{`Android Lifecycle 3.0.0`}</li>
      <li parentName="ul">{`Android Identity 3.0.0`}</li>
      <li parentName="ul">{`Android Profile 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Experience Platform Assurance 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Experience Platform Edge Network 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Journey Optimizer 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Journey Optimizer - Decisioning 3.0.0`}</li>
      <li parentName="ul">{`Android Consent for Edge Network 3.0.0`}</li>
      <li parentName="ul">{`Android Identity for Edge Network 3.0.0`}</li>
      <li parentName="ul">{`Android Media for Edge Network 3.0.0`}</li>
      <li parentName="ul">{`Android Edge Bridge 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Analytics 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Analytics - Media Analytics for Audio & Video 3.1.0`}</li>
      <li parentName="ul">{`Android Adobe Audience Manager 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Campaign Standard 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Campaign Classic 3.0.0`}</li>
      <li parentName="ul">{`Android Adobe Target 3.0.0`}</li>
      <li parentName="ul">{`Android Places Service 3.0.0`}</li>
    </ul>
    <p><strong parentName="p">{`Android BOM 3.0.0`}</strong>{` has been released and is the recommended way to manage these dependencies.`}</p>
    <p>{`For help on moving to these versions, and information on deprecated APIs please see:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../resources/migration/android/migrate-to-3x.md"
        }}>{`Migration guide`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../resources/migration/android/migrate-to-3x.md#frequently-asked-questions"
        }}>{`Migration FAQ`}</a></li>
    </ul>
    <h3 {...{
      "id": "android-bom-300"
    }}>{`Android BOM 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.6)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (3.0.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:analytics`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.3`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:audience`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaign`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.6`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.5`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.6.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edge`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.4.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgebridge`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgeconsent`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgeidentity`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:edgemedia`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:identity`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.3`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:lifecycle`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.4`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:media`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.1.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:optimize`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:places`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:signal`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:target`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.3`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:userprofile`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`3.0.0`}</strong></td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-messaging-300"
    }}>{`Android Messaging 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/adobe-journey-optimizer/index.md"
      }}>{`Adobe Journey Optimizer`}</a>{` for Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Migrated the in-app message feature to use Jetpack Compose based UI Services from MobileCore 3.0.0.`}</li>
      <li parentName="ul">{`Adds support for code-based experiences.`}</li>
      <li parentName="ul">{`Fixed a bug that caused Activity restarts when processing push notification click URIs.`}</li>
    </ul>
    <h3 {...{
      "id": "android-optimize-300"
    }}>{`Android Optimize 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/adobe-journey-optimizer-decisioning/index.md"
      }}>{`Adobe Journey Optimizer - Decisioning Extension`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Renamed class `}<inlineCode parentName="li">{`Proposition`}</inlineCode>{` to `}<inlineCode parentName="li">{`OptimizeProposition`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "april-2-2024"
    }}>{`April 2, 2024`}</h2>
    <h3 {...{
      "id": "android-edge-300"
    }}>{`Android Edge 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/edge-network/index.md"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Removed deprecated function `}<inlineCode parentName="li">{`Formatters.dateToISO8601String()`}</inlineCode>{`, replaced by `}<inlineCode parentName="li">{`TimeUtils.getISO8601UTCDateWithMilliseconds()`}</inlineCode>{` in MobileCore.`}</li>
      <li parentName="ul">{`Removed deprecated function `}<inlineCode parentName="li">{`Formatters.dateToShortDateString()`}</inlineCode>{`, replaced by `}<inlineCode parentName="li">{`TimeUtils.getISO8601FullDate()`}</inlineCode>{` in MobileCore.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgeconsent-300"
    }}>{`Android EdgeConsent 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/consent-for-edge-network/index.md"
      }}>{`Consent for Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgeidentity-300"
    }}>{`Android EdgeIdentity 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/identity-for-edge-network/index.md"
      }}>{`Identity for Edge Network`}</a>{` Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgemedia-300"
    }}>{`Android EdgeMedia 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/media-for-edge-network/index.md"
      }}>{`Adobe Streaming Media for Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edgebridge-300"
    }}>{`Android EdgeBridge 3.0.0`}</h3>
    <p>{`Major version update for Edge Bridge for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Updated Edge Bridge data format to enhance support for migrating to sending data via Edge Network to Adobe Analytics and reduce the effort required for mapping data to XDM.`}</li>
      <li parentName="ul">{`If you are currently using Edge Bridge version 2.x and you are mapping data to XDM in your datastream, adjustments will be necessary when adopting version 3.0.0. For more details, please review the `}<a parentName="li" {...{
          "href": "../../resources/migration/android/migrate-to-3x.md"
        }}>{`migration`}</a>{` documentation.`}</li>
    </ul>
    <h3 {...{
      "id": "android-analytics-300"
    }}>{`Android Analytics 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-analytics/index.md"
      }}>{`Adobe Analytics`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h3 {...{
      "id": "android-media-310"
    }}>{`Android Media 3.1.0`}</h3>
    <p>{`Version update to 3.1.0 for `}<a parentName="p" {...{
        "href": "../../solution/adobe-media-analytics/index.md"
      }}>{`Adobe Analytics - Media Analytics workflows`}</a>{` Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline and improved logging.`}</li>
    </ul>
    <p>{`Please note that the version 3.0.0 of the Adobe Analytics - Media Analytics extension is compatible with Mobile Core 2.x. The increment to 3.1.0 was preferred for this release in order to synchronize all extensions to same major version.`}</p>
    <h3 {...{
      "id": "android-audience-300"
    }}>{`Android Audience 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-audience-manager/index.md"
      }}>{`Adobe Audience Manager`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-classic-300"
    }}>{`Android Campaign Classic 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-campaign-classic/index.md"
      }}>{`Campaign Classic`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`The SDK is now compatible with Kotlin 1.8 and higher.`}</li>
      <li parentName="ul">{`Removed the out-of-the-box push template handling code. This functionality will be available in a future Core 3.x release.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-standard-300"
    }}>{`Android Campaign Standard 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-campaign-standard/index.md"
      }}>{`Campaign Standard`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`The SDK is now compatible with Kotlin 1.8 and higher.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Migrated Campaign SDK to use Jetpack Compose based UI Services from MobileCore 3.0.0`}</li>
      <li parentName="ul">{`Moved code to create and track local notifications from Mobile Core to Campaign.`}</li>
    </ul>
    <h3 {...{
      "id": "android-target-300"
    }}>{`Android Target 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-target/index.md"
      }}>{`Target`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Migrated Target Preview to use Jetpack Compose based UI Services from MobileCore 3.0.0`}</li>
    </ul>
    <h3 {...{
      "id": "android-places-300"
    }}>{`Android Places 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/places/index.md"
      }}>{`Places`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
    </ul>
    <h2 {...{
      "id": "april-1-2024"
    }}>{`April 1, 2024`}</h2>
    <h3 {...{
      "id": "android-core-300"
    }}>{`Android Core 3.0.0`}</h3>
    <p>{`Major version update of Adobe Experience Platform Core Android SDK is live!`}</p>
    <p>{`Please note that the current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`The SDK is now compatible with Kotlin 1.8 and higher.`}</li>
      <li parentName="ul">{`Migrated UI service to use Jetpack Compose.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`MobileCore.registerExtension(...)`}</inlineCode>{` and `}<inlineCode parentName="li">{`MobileCore.start()`}</inlineCode>{` APIs. Use the `}<inlineCode parentName="li">{`MobileCore.registerExtensions(...)`}</inlineCode>{` API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Removed `}<inlineCode parentName="li">{`MobileCore.setMessagingDelegate`}</inlineCode>{`, `}<inlineCode parentName="li">{`MobileCore.getMessagingDelegate`}</inlineCode>{` APIs which were used to control the display of in-app messages. Migrate to `}<inlineCode parentName="li">{`com.adobe.marketing.mobile.services.ui.PresentationDelegate`}</inlineCode>{` and use `}<inlineCode parentName="li">{`ServiceProvider.getUIService().setPresentationDelegate`}</inlineCode>{` API instead.`}</li>
      <li parentName="ul">{`Removed other APIs related to extension development which were deprecated in 2.0.0.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h3 {...{
      "id": "android-signal-300"
    }}>{`Android Signal 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../base/mobile-core/signal/index.md"
      }}>{`Signal`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`The SDK is now compatible with Kotlin 1.8 and higher.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-300"
    }}>{`Android Lifecycle 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../base/mobile-core/lifecycle/index.md"
      }}>{`Lifecycle`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-300"
    }}>{`Android Identity 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../base/mobile-core/identity/index.md"
      }}>{`Identity`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h3 {...{
      "id": "android-userprofile-300"
    }}>{`Android UserProfile 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../base/profile/index.md"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the `}<inlineCode parentName="li">{`MobileCore.registerExtensions()`}</inlineCode>{` API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`UserProfile.updateUserAttribute`}</inlineCode>{` API. Use the `}<inlineCode parentName="li">{`UserProfile.updateUserAttributes`}</inlineCode>{` API instead.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`UserProfile.removeUserAttribute`}</inlineCode>{` API. Use the `}<inlineCode parentName="li">{`UserProfile.removeUserAttributes`}</inlineCode>{` API instead.`}</li>
    </ul>
    <h3 {...{
      "id": "android-assurance-300"
    }}>{`Android Assurance 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../base/assurance/index.md"
      }}>{`Adobe Experience Platform Assurance`}</a>{` on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`The SDK is now compatible with Kotlin 1.8 and higher.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the `}<inlineCode parentName="li">{`MobileCore.registerExtensions()`}</inlineCode>{` API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Migrated SDK UI components to Jetpack Compose.`}</li>
    </ul>
    <h2 {...{
      "id": "march-20-2024"
    }}>{`March 20, 2024`}</h2>
    <h3 {...{
      "id": "ios-mobile-core-5x-and-compatible-extensions"
    }}>{`iOS Mobile Core 5.x and compatible extensions`}</h3>
    <p>{`Starting May 7th, 2024, our iOS releases will include signed XCFrameworks. Additionally, we've updated all our 5.0.0 releases with signed XCFrameworks.`}</p>
    <p>{`New major version of the Mobile Core SDK for iOS has been released along with updates to other extensions. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0 (for extensions which support tvOS).`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Include a privacy manifest for AEPCore and AEPServices.`}</li>
    </ul>
    <p>{`Note that all these extensions must be updated together.`}</p>
    <ul>
      <li parentName="ul">{`iOS Mobile Core 5.0.0`}</li>
      <li parentName="ul">{`iOS Signal 5.0.0`}</li>
      <li parentName="ul">{`iOS Lifecycle 5.0.0`}</li>
      <li parentName="ul">{`iOS Identity 5.0.0`}</li>
      <li parentName="ul">{`iOS Profile 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Experience Platform Assurance 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Experience Platform Edge Network 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Journey Optimizer 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Journey Optimizer - Decisioning 5.0.0`}</li>
      <li parentName="ul">{`iOS Consent for Edge Network 5.0.0`}</li>
      <li parentName="ul">{`iOS Identity for Edge Network 5.0.0`}</li>
      <li parentName="ul">{`iOS Media for Edge Network 5.0.0`}</li>
      <li parentName="ul">{`iOS Edge Bridge 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Analytics 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Analytics - Media Analytics for Audio & Video 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Audience Manager 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Campaign Standard 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Campaign Classic 5.0.0`}</li>
      <li parentName="ul">{`iOS Adobe Target 5.0.0`}</li>
      <li parentName="ul">{`iOS Places Service 5.0.0`}</li>
    </ul>
    <p>{`To learn how Apple's privacy related announcements made in WWDC of 2023 affect the Mobile SDK, please read the guide on `}<a parentName="p" {...{
        "href": "../../resources/privacy-manifest.md"
      }}>{`iOS privacy manifest and related changes`}</a>{`.`}</p>
    <p>{`For help on moving to these versions, and information on deprecated APIs please see:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../resources/migration/ios/index.md"
        }}>{`Migration guide`}</a></li>
    </ul>
    <h3 {...{
      "id": "ios-userprofile-500"
    }}>{`iOS UserProfile 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../base/profile/index.md"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-assurance-500"
    }}>{`iOS Assurance 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../base/assurance/index.md"
      }}>{`Adobe Experience Platform Assurance`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-messaging-500"
    }}>{`iOS Messaging 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/adobe-journey-optimizer/index.md"
      }}>{`Adobe Journey Optimizer`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Added `}<a parentName="li" {...{
          "href": "./../../edge/adobe-journey-optimizer/api-reference/#handlenotificationresponse"
        }}><inlineCode parentName="a">{`handleNotificationResponse(_:urlHandler:closure:)`}</inlineCode></a>{` API to provide more control over URL handling from `}<inlineCode parentName="li">{`UNNotificationResponse`}</inlineCode>{` objects.`}
        <ul parentName="li">
          <li parentName="ul">{`Removed deprecated public API `}<inlineCode parentName="li">{`Messaging.handleNotificationResponse(_:applicationOpened:withCustomActionId:)`}</inlineCode>{`.`}</li>
          <li parentName="ul">{`Removed public API `}<inlineCode parentName="li">{`Messaging.handleNotificationResponse(_:closure:)`}</inlineCode>{` API.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/en/docs/journey-optimizer/using/code-based-experience/get-started-code-based"
        }}>{`Code Based Experiences`}</a>{`.`}
        <ul parentName="li">
          <li parentName="ul">{`Added public API `}<a parentName="li" {...{
              "href": "./../../edge/adobe-journey-optimizer/code-based/api-reference/#updatepropositionsforsurfaces"
            }}><inlineCode parentName="a">{`Messaging.updatePropositionsForSurfaces(_)`}</inlineCode></a>{`.`}</li>
          <li parentName="ul">{`Added public API `}<a parentName="li" {...{
              "href": "./../../edge/adobe-journey-optimizer/code-based/api-reference/#getpropositionsforsurfaces"
            }}><inlineCode parentName="a">{`Messaging.getPropositionsForSurfaces(_:completion:)`}</inlineCode></a>{`.`}</li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "ios-optimize-500"
    }}>{`iOS Optimize 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/adobe-journey-optimizer-decisioning/index.md"
      }}>{`Adobe Journey Optimizer - Decisioning Extension`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Renamed class `}<inlineCode parentName="li">{`Proposition`}</inlineCode>{` to `}<inlineCode parentName="li">{`OptimizeProposition`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edgeconsent-500"
    }}>{`iOS EdgeConsent 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/consent-for-edge-network/index.md"
      }}>{`Consent for Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edgemedia-500"
    }}>{`iOS EdgeMedia 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/media-for-edge-network/index.md"
      }}>{`Adobe Streaming Media for Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edgebridge-500"
    }}>{`iOS EdgeBridge 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-analytics/migrate-to-edge-network.md"
      }}>{`Edge Bridge`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Updated Edge Bridge data format to enhance support for migrating to sending data via Edge Network to Adobe Analytics and reduce the effort required for mapping data to XDM.`}</li>
      <li parentName="ul">{`If you are currently using Edge Bridge version 4.0.0 and you are mapping data to XDM in your datastream, adjustments will be necessary when adopting version 5.0.0. For more details, please review the `}<a parentName="li" {...{
          "href": "../../resources/migration/ios/migrate-to-5x.md"
        }}>{`migration`}</a>{` documentation.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-500"
    }}>{`iOS Analytics 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-analytics/index.md"
      }}>{`Adobe Analytics`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-media-500"
    }}>{`iOS Media 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-media-analytics/index.md"
      }}>{`Adobe Analytics - Media Analytics workflows`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-audience-500"
    }}>{`iOS Audience 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-audience-manager/index.md"
      }}>{`Adobe Audience Manager`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-classic-500"
    }}>{`iOS Campaign Classic 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-campaign-classic/index.md"
      }}>{`Campaign Classic`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-standard-500"
    }}>{`iOS Campaign Standard 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-campaign-standard/index.md"
      }}>{`Campaign Standard`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-target-500"
    }}>{`iOS Target 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/adobe-target/index.md"
      }}>{`Target`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Fixed a bug when using Target Preview on device that caused the floating button to remain visible when a preview selection was active.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-places-500"
    }}>{`iOS Places 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../solution/places/index.md"
      }}>{`Places`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Fixes a bug where limit was not being respected in calls to `}<inlineCode parentName="li">{`getNearbyPointsOfInterest`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "march-19-2024"
    }}>{`March 19, 2024`}</h2>
    <h3 {...{
      "id": "ios-core-500"
    }}>{`iOS Core 5.0.0`}</h3>
    <p>{`Major version update of Adobe Experience Platform Core iOS SDKs are live! It contains the following extensions:`}</p>
    <ul>
      <li parentName="ul">{`Core 5.0.0`}</li>
      <li parentName="ul">{`Identity 5.0.0`}</li>
      <li parentName="ul">{`Signal 5.0.0`}</li>
      <li parentName="ul">{`Lifecycle 5.0.0`}</li>
    </ul>
    <p>{`Please note that the current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
      <li parentName="ul">{`Include a privacy manifest for AEPCore and AEPServices.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edge-500"
    }}>{`iOS Edge 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/edge-network/index.md"
      }}>{`Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edgeidentity-500"
    }}>{`iOS EdgeIdentity 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "../../edge/identity-for-edge-network/index.md"
      }}>{`Identity for Edge Network`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0 and tvOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h2 {...{
      "id": "march-12-2024"
    }}>{`March 12, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-296"
    }}>{`Android BOM 2.9.6`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.5)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.6)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.4`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.5`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "march-11-2024"
    }}>{`March 11, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-215"
    }}>{`Android Campaign Classic 2.1.5`}</h3>
    <ul>
      <li parentName="ul">{`Re-add parsing of the `}<inlineCode parentName="li">{`adb_icon`}</inlineCode>{` key value pair from the push template payload. The value will be used to locate and then set a notification small icon from the app's bundle if the `}<inlineCode parentName="li">{`adb_small_icon`}</inlineCode>{` key value pair is not present in the push payload.`}</li>
    </ul>
    <h2 {...{
      "id": "march-8-2024"
    }}>{`March 8, 2024`}</h2>
    <h3 {...{
      "id": "ios-userprofile-401"
    }}>{`iOS UserProfile 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fix an issue where dependency versions did not have an upper bound restriction.`}</li>
    </ul>
    <h2 {...{
      "id": "march-7-2024"
    }}>{`March 7, 2024`}</h2>
    <h3 {...{
      "id": "roku-sdk-110"
    }}>{`Roku SDK 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Streaming Media for Edge Network`}
        <ul parentName="li">
          <li parentName="ul">{`Added new APIs and configuration for tracking media.`}</li>
          <li parentName="ul">{`Customizable ping interval.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Added support to create multiple instances of the SDK.`}</li>
      <li parentName="ul">{`Support non-xdm data in `}<inlineCode parentName="li">{`SendEvent`}</inlineCode>{` API`}</li>
      <li parentName="ul">{`A comprehensive `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-roku/blob/main/Documentation/media-migration.md"
        }}>{`migration guide`}</a>{` to transition from `}<a parentName="li" {...{
          "href": "https://github.com/Adobe-Marketing-Cloud/media-sdks/tree/master/sdks/roku"
        }}>{`Adobe Media SDK`}</a>{` to `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-roku"
        }}>{`Adobe Experience Platform Roku SDK`}</a>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-assurance-412"
    }}>{`iOS Assurance 4.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fix an issue where dependency versions did not have an upper bound restriction.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-401"
    }}>{`iOS Analytics 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edgeconsent-401"
    }}>{`iOS EdgeConsent 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h2 {...{
      "id": "march-6-2024"
    }}>{`March 6, 2024`}</h2>
    <h3 {...{
      "id": "ios-edgemedia-401"
    }}>{`iOS EdgeMedia 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edgeidentity-401"
    }}>{`iOS EdgeIdentity 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edge-431"
    }}>{`iOS Edge 4.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-edgebridge-411"
    }}>{`iOS EdgeBridge 4.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-media-402"
    }}>{`iOS Media 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-audience-401"
    }}>{`iOS Audience 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h3 {...{
      "id": "android-bom-295"
    }}>{`Android BOM 2.9.5`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.4)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.5)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:messaging`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "march-5-2024"
    }}>{`March 5, 2024`}</h2>
    <h3 {...{
      "id": "android-messaging-221"
    }}>{`Android Messaging 2.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Handle a null network connection exception which was causing the Messaging extension to fail to be registered.`}</li>
    </ul>
    <h2 {...{
      "id": "february-29-2024"
    }}>{`February 29, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-294"
    }}>{`Android BOM 2.9.4`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.3)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.4)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.3`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.4`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "february-28-2024"
    }}>{`February 28, 2024`}</h2>
    <h3 {...{
      "id": "ios-messaging-411"
    }}>{`iOS Messaging 4.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-standard-401"
    }}>{`iOS Campaign Standard 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec`}</li>
    </ul>
    <h3 {...{
      "id": "ios-optimize-403"
    }}>{`iOS Optimize 4.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-classic-401"
    }}>{`iOS Campaign Classic 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec`}</li>
    </ul>
    <h3 {...{
      "id": "ios-target-404"
    }}>{`iOS Target 4.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-classic-214"
    }}>{`Android Campaign Classic 2.1.4`}</h3>
    <ul>
      <li parentName="ul">{`Add support for setting a large notification icon from a bundled drawable or a remote image url.`}</li>
      <li parentName="ul">{`Use the defined Push Template action URI for carousel items that do not have an action URI.`}</li>
      <li parentName="ul">{`Fix a NPE seen when a tag string was not provided for a basic template notification.`}</li>
    </ul>
    <h2 {...{
      "id": "february-27-2024"
    }}>{`February 27, 2024`}</h2>
    <h3 {...{
      "id": "ios-places-411"
    }}>{`iOS Places 4.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec`}</li>
    </ul>
    <h2 {...{
      "id": "february-15-2024"
    }}>{`February 15, 2024`}</h2>
    <h3 {...{
      "id": "ios-core-423"
    }}>{`iOS Core 4.2.3`}</h3>
    <ul>
      <li parentName="ul">{`Fix podspec dependencies not being restricted to current major version.`}</li>
      <li parentName="ul">{`Fixed an issue that was allowing in-app messages without content to be displayed.`}</li>
    </ul>
    <h2 {...{
      "id": "february-6-2024"
    }}>{`February 6, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-293"
    }}>{`Android BOM 2.9.3`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.2)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.3)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "february-2-2024"
    }}>{`February 2, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-213"
    }}>{`Android Campaign Classic 2.1.3`}</h3>
    <ul>
      <li parentName="ul">{`Fix key value pair extraction from a push notification data payload. Push data payload values are preferred over push notification payload values.`}</li>
    </ul>
    <h2 {...{
      "id": "february-1-2024"
    }}>{`February 1, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-292"
    }}>{`Android BOM 2.9.2`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.2)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:assurance`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.0`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.2.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:target`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.2`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.3`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "january-30-2024"
    }}>{`January 30, 2024`}</h2>
    <h3 {...{
      "id": "android-assurance-221"
    }}>{`Android Assurance 2.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue that caused large Assurance events to be sent with malformed payload.`}</li>
    </ul>
    <h2 {...{
      "id": "january-29-2024"
    }}>{`January 29, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-212"
    }}>{`Android Campaign Classic 2.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fix notification sticky behavior`}</li>
    </ul>
    <h2 {...{
      "id": "january-26-2024"
    }}>{`January 26, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-291"
    }}>{`Android BOM 2.9.1`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.0)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.1)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:core`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.6.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.6.2`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaignclassic`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h3 {...{
      "id": "android-core-262"
    }}>{`Android Core 2.6.2`}</h3>
    <ul>
      <li parentName="ul">{`Add array support for token replacement in the launch rules engine.`}</li>
      <li parentName="ul">{`The code used to fix issues on Android 8/8.1 has been restricted from execution on other Android OS versions.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-target-403"
    }}>{`iOS Target 4.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where Target response tokens were not returned in `}<inlineCode parentName="li">{`TargetRequest`}</inlineCode>{`'s `}<inlineCode parentName="li">{`contentWithDataCallback`}</inlineCode>{` callback when using `}<inlineCode parentName="li">{`retrieveLocationContent`}</inlineCode>{` API.`}</li>
    </ul>
    <p>{`The response tokens should be parsed as `}<inlineCode parentName="p">{`[String: Any]`}</inlineCode>{`. For details, see usage example for `}<a parentName="p" {...{
        "href": "../../solution/adobe-target/api-reference.md#retrievelocationcontent"
      }}>{`retrieveLocationContent`}</a>{` API.`}</p>
    <h3 {...{
      "id": "android-target-203"
    }}>{`Android Target 2.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where Target response tokens were not returned in `}<inlineCode parentName="li">{`TargetRequest`}</inlineCode>{`'s `}<inlineCode parentName="li">{`AdobeTargetDetailedCallback`}</inlineCode>{` callback when using `}<inlineCode parentName="li">{`retrieveLocationContent`}</inlineCode>{` API.`}</li>
    </ul>
    <p>{`The response tokens should be parsed as `}<inlineCode parentName="p">{`Map<String: Object>`}</inlineCode>{`. For details, see usage example for `}<a parentName="p" {...{
        "href": "../../solution/adobe-target/api-reference.md#retrievelocationcontent"
      }}>{`retrieveLocationContent`}</a>{` API.`}</p>
    <h2 {...{
      "id": "january-25-2024"
    }}>{`January 25, 2024`}</h2>
    <h3 {...{
      "id": "react-native-edge-library-510"
    }}>{`React Native Edge library 5.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support to customize datastream configurations on a per-event basis using the sendEvent API.
This release updates dependencies on native Edge Network SDK to minimum v4.3.0 (iOS) and v2.4.0 (Android).
Refer to API doc `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/edge#sendevent"
        }}>{`here`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "january-23-2024"
    }}>{`January 23, 2024`}</h2>
    <h3 {...{
      "id": "android-bom-290"
    }}>{`Android BOM 2.9.0`}</h3>
    <ul>
      <li parentName="ul">{`This BOM (`}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`Bill of Materials`}</a>{`) release includes changes to the following Android extensions.`}</li>
    </ul>
    <Accordion mdxType="Accordion">
      <AccordionItem header='Expand' mdxType="AccordionItem">
        <table>
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Extension artifact`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.8.1)`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`BOM (2.9.0)`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`com.adobe.marketing.mobile:campaignclassic`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.0.1`}</strong></td>
              <td parentName="tr" {...{
                "align": null
              }}><strong parentName="td">{`2.1.1`}</strong></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:analytics`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:assurance`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:audience`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:campaign`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.6`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:core`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.6.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.4.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgebridge`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeconsent`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgeidentity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:edgemedia`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:identity`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.3`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:lifecycle`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.4`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:media`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`3.0.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:messaging`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.2.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:optimize`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:places`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.1.0`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:signal`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:target`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.2`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}>{`com.adobe.marketing.mobile:userprofile`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
              <td parentName="tr" {...{
                "align": null
              }}>{`2.0.1`}</td>
            </tr>
          </tbody>
        </table>
      </AccordionItem>
    </Accordion>
    <h2 {...{
      "id": "january-22-2024"
    }}>{`January 22, 2024`}</h2>
    <h3 {...{
      "id": "ios-core-422"
    }}>{`iOS Core 4.2.2`}</h3>
    <ul>
      <li parentName="ul">{`Add array support for token replacement in the launch rules engine.`}</li>
      <li parentName="ul">{`Fixed a caching issue that could cause display problems when two or more in-app messages were being triggered by identical conditions.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-classic-211"
    }}>{`Android Campaign Classic 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug with manual carousel buttons`}</li>
    </ul>
    <h2 {...{
      "id": "january-19-2024"
    }}>{`January 19, 2024`}</h2>
    <h3 {...{
      "id": "android-campaign-classic-210"
    }}>{`Android Campaign Classic 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for out-of-the-box push notifications:`}
        <ul parentName="li">
          <li parentName="ul">{`Basic notifications, including remind me later and call-to-action functionality`}</li>
          <li parentName="ul">{`Manual and automatic image carousels of three to five items`}</li>
        </ul>
      </li>
    </ul>
    <p>{`See a full description of the new `}<a parentName="p" {...{
        "href": "./../../solution/adobe-campaign-classic/push-templates"
      }}>{`push template payloads`}</a>{`.`}</p>
    <h2 {...{
      "id": "january-17-2024"
    }}>{`January 17, 2024`}</h2>
    <h3 {...{
      "id": "ios-assurance-411"
    }}>{`iOS Assurance 4.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a race condition which could happen when the Assurance session is terminated.`}</li>
    </ul>
    <h2 {...{
      "id": "january-8-2024"
    }}>{`January 8, 2024`}</h2>
    <h3 {...{
      "id": "ios-media-401"
    }}>{`iOS Media 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixes configuration handling where the Collection API Server with first-party domain and /va path was not accepted.`}</li>
    </ul>
    <h2 {...{
      "id": "january-4-2024"
    }}>{`January 4, 2024`}</h2>
    <h3 {...{
      "id": "ios-core-421"
    }}>{`iOS Core 4.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Reverts storage for tvOS back to UserDefaults.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      